import { ApiError } from './apiClient'

/**
 * Kalimat untuk menampilkan kegagalan aksi: pesan server, kode HTTP dan kode
 * error, ditambah pesan per field bila ada. Dipakai di dialog dan umpan balik
 * aksi supaya penyebabnya selalu terlihat operator.
 */
export function describeError(error: unknown): string {
  if (error instanceof ApiError) {
    const detail = error.fields.map((item) => item.message).join(' ')
    const head = `${error.message} (kode HTTP ${error.status}${error.code ? `, ${error.code}` : ''})`
    return detail ? `${head}. ${detail}` : head
  }
  if (error instanceof Error && error.message) {
    return error.message
  }
  return 'Permintaan gagal karena penyebab yang tidak diketahui.'
}

/** Apakah respons validasi menyebut field tertentu. */
export function hasFieldError(error: unknown, field: string): boolean {
  return error instanceof ApiError && error.fields.some((item) => item.field === field)
}
